export default __webpack_public_path__ + "static/media/ICON_SignOut.8f366b57.svg";